import EmailVerification from "src/pages/email-verification";
import EidVerification from "src/pages/eid-verification";
import KyxClientForm from "src/pages/client-form";
import PhoneVerification from "src/pages/phone-verification";
import VerificationChoose from "src/pages/verification-choose";
import AddressVerification from "src/pages/address-verification";
import Final from "src/pages/final";
import BankVerification from "src/pages/bank-verification";
import LocationVerification from "src/pages/location-verification";
import SelfieLiveness from "src/pages/selfie/SelfieLiveness";
import SelfieOnly from "src/pages/selfie/SelfieOnly";
import FileUploadPage from "src/pages/file-upload";
import PaymentVerification from "src/pages/payment-verification";

export const pageComponents = {
  verification: VerificationChoose,
  liveness: SelfieLiveness,
  selfieOnly: SelfieOnly,
  emailVerification: EmailVerification,
  eidVerification: EidVerification,
  phoneVerification: PhoneVerification,
  addressVerification: AddressVerification,
  form: KyxClientForm,
  flow: KyxClientForm,
  bankVerification: BankVerification,
  paymentVerification: PaymentVerification,
  geolocationVerification: LocationVerification,
  documentVerification: FileUploadPage,
  otherKyc: FileUploadPage, //miscellaneousDocumentUpload
  final: Final
};
